/**
 * @generated SignedSource<<ca23db0965f4901c5e2b5ae20541c4d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AuditActorType = "AGENT" | "USER" | "%future added value";
export type AuditEventType = "AGENT_TOKEN_CREATED" | "AGENT_TOKEN_REVOKED" | "AGENT_TOKEN_UPDATED" | "API_ACCESS_TOKEN_CREATED" | "API_ACCESS_TOKEN_DELETED" | "API_ACCESS_TOKEN_ORGANIZATION_ACCESS_REVOKED" | "API_ACCESS_TOKEN_UPDATED" | "AUTHORIZATION_CREATED" | "AUTHORIZATION_DELETED" | "CLUSTER_CREATED" | "CLUSTER_DELETED" | "CLUSTER_PERMISSION_CREATED" | "CLUSTER_PERMISSION_DELETED" | "CLUSTER_QUEUE_CREATED" | "CLUSTER_QUEUE_DELETED" | "CLUSTER_QUEUE_TOKEN_CREATED" | "CLUSTER_QUEUE_TOKEN_DELETED" | "CLUSTER_QUEUE_TOKEN_UPDATED" | "CLUSTER_QUEUE_UPDATED" | "CLUSTER_TOKEN_CREATED" | "CLUSTER_TOKEN_DELETED" | "CLUSTER_TOKEN_UPDATED" | "CLUSTER_UPDATED" | "COMPOSITE_REGISTRY_UPSTREAM_ADDED" | "COMPOSITE_REGISTRY_UPSTREAM_REMOVED" | "JOB_TERMINAL_SESSION_STARTED" | "NOTIFICATION_SERVICE_BROKEN" | "NOTIFICATION_SERVICE_CREATED" | "NOTIFICATION_SERVICE_DELETED" | "NOTIFICATION_SERVICE_DISABLED" | "NOTIFICATION_SERVICE_ENABLED" | "NOTIFICATION_SERVICE_UPDATED" | "ORGANIZATION_BANNER_CREATED" | "ORGANIZATION_BANNER_DELETED" | "ORGANIZATION_BANNER_UPDATED" | "ORGANIZATION_BUILD_EXPORT_UPDATED" | "ORGANIZATION_CREATED" | "ORGANIZATION_DELETED" | "ORGANIZATION_IMPERSONATION_REQUEST_APPROVED" | "ORGANIZATION_IMPERSONATION_REQUEST_REVOKED" | "ORGANIZATION_INVITATION_ACCEPTED" | "ORGANIZATION_INVITATION_CREATED" | "ORGANIZATION_INVITATION_RESENT" | "ORGANIZATION_INVITATION_REVOKED" | "ORGANIZATION_MEMBER_CREATED" | "ORGANIZATION_MEMBER_DELETED" | "ORGANIZATION_MEMBER_UPDATED" | "ORGANIZATION_TEAMS_DISABLED" | "ORGANIZATION_TEAMS_ENABLED" | "ORGANIZATION_UPDATED" | "PIPELINE_CREATED" | "PIPELINE_DELETED" | "PIPELINE_SCHEDULE_CREATED" | "PIPELINE_SCHEDULE_DELETED" | "PIPELINE_SCHEDULE_UPDATED" | "PIPELINE_TEMPLATE_CREATED" | "PIPELINE_TEMPLATE_DELETED" | "PIPELINE_TEMPLATE_UPDATED" | "PIPELINE_UPDATED" | "PIPELINE_VISIBILITY_CHANGED" | "PIPELINE_WEBHOOK_URL_ROTATED" | "PORTAL_CREATED" | "PORTAL_DELETED" | "PORTAL_UPDATED" | "REGISTRY_CREATED" | "REGISTRY_DELETED" | "REGISTRY_TOKEN_CREATED" | "REGISTRY_TOKEN_DELETED" | "REGISTRY_TOKEN_UPDATED" | "REGISTRY_UPDATED" | "REGISTRY_VISIBILITY_CHANGED" | "RULE_CREATED" | "RULE_DELETED" | "RULE_UPDATED" | "SCM_PIPELINE_SETTINGS_CREATED" | "SCM_PIPELINE_SETTINGS_DELETED" | "SCM_PIPELINE_SETTINGS_UPDATED" | "SCM_REPOSITORY_HOST_CREATED" | "SCM_REPOSITORY_HOST_DESTROYED" | "SCM_REPOSITORY_HOST_UPDATED" | "SCM_SERVICE_CREATED" | "SCM_SERVICE_DELETED" | "SCM_SERVICE_UPDATED" | "SECRET_CREATED" | "SECRET_DELETED" | "SECRET_QUERIED" | "SECRET_READ" | "SECRET_UPDATED" | "SSO_PROVIDER_CREATED" | "SSO_PROVIDER_DELETED" | "SSO_PROVIDER_DISABLED" | "SSO_PROVIDER_ENABLED" | "SSO_PROVIDER_UPDATED" | "STORAGE_CREATED" | "SUBSCRIPTION_ACTIVATED" | "SUBSCRIPTION_CANCELED" | "SUBSCRIPTION_PLAN_ADDED" | "SUBSCRIPTION_PLAN_CANCELATION_SCHEDULED" | "SUBSCRIPTION_PLAN_CANCELED" | "SUBSCRIPTION_PLAN_CHANGED" | "SUBSCRIPTION_PLAN_CHANGE_SCHEDULED" | "SUBSCRIPTION_SCHEDULED_PLAN_CHANGE_CANCELED" | "SUITE_API_TOKEN_REGENERATED" | "SUITE_CREATED" | "SUITE_DELETED" | "SUITE_MONITOR_CREATED" | "SUITE_MONITOR_DELETED" | "SUITE_MONITOR_UPDATED" | "SUITE_UPDATED" | "SUITE_VISIBILITY_CHANGED" | "TEAM_CREATED" | "TEAM_DELETED" | "TEAM_MEMBER_CREATED" | "TEAM_MEMBER_DELETED" | "TEAM_MEMBER_UPDATED" | "TEAM_PIPELINE_CREATED" | "TEAM_PIPELINE_DELETED" | "TEAM_PIPELINE_UPDATED" | "TEAM_REGISTRY_CREATED" | "TEAM_REGISTRY_DELETED" | "TEAM_REGISTRY_UPDATED" | "TEAM_SUITE_CREATED" | "TEAM_SUITE_DELETED" | "TEAM_SUITE_UPDATED" | "TEAM_UPDATED" | "USER_API_ACCESS_TOKEN_ORGANIZATION_ACCESS_ADDED" | "USER_API_ACCESS_TOKEN_ORGANIZATION_ACCESS_REMOVED" | "USER_EMAIL_CREATED" | "USER_EMAIL_DELETED" | "USER_EMAIL_MARKED_PRIMARY" | "USER_EMAIL_VERIFIED" | "USER_IMPERSONATED" | "USER_PASSWORD_RESET" | "USER_PASSWORD_RESET_REQUESTED" | "USER_TOTP_ACTIVATED" | "USER_TOTP_CREATED" | "USER_TOTP_DELETED" | "USER_UPDATED" | "%future added value";
export type AuditSubjectType = "AGENT_TOKEN" | "API_ACCESS_TOKEN" | "AUTHORIZATION" | "CLUSTER" | "CLUSTER_PERMISSION" | "CLUSTER_QUEUE" | "CLUSTER_QUEUE_TOKEN" | "CLUSTER_TOKEN" | "COMPOSITE_REGISTRY_UPSTREAM" | "JOB" | "NOTIFICATION_SERVICE" | "ORGANIZATION" | "ORGANIZATION_BANNER" | "ORGANIZATION_IMPERSONATION_REQUEST" | "ORGANIZATION_INVITATION" | "ORGANIZATION_MEMBER" | "PIPELINE" | "PIPELINE_SCHEDULE" | "PIPELINE_TEMPLATE" | "PORTAL" | "REGISTRY" | "REGISTRY_TOKEN" | "RULE" | "SCM_PIPELINE_SETTINGS" | "SCM_REPOSITORY_HOST" | "SCM_SERVICE" | "SECRET" | "SSO_PROVIDER" | "SUBSCRIPTION" | "SUITE" | "SUITE_MONITOR" | "TEAM" | "TEAM_MEMBER" | "TEAM_PIPELINE" | "TEAM_REGISTRY" | "TEAM_SUITE" | "USER" | "USER_EMAIL" | "USER_TOTP" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type row_auditEvent$data = {
  readonly actor: {
    readonly name: string | null;
    readonly node: {
      readonly avatar?: {
        readonly url: string;
      };
      readonly name?: string;
    } | null;
    readonly type: AuditActorType | null;
  } | null;
  readonly context: {
    readonly __typename: string;
  } | null;
  readonly occurredAt: any;
  readonly subject: {
    readonly name: string | null;
    readonly node: {
      readonly name?: string;
      readonly organization?: {
        readonly name: string;
      };
      readonly pipeline?: {
        readonly name: string;
      } | null;
      readonly registry?: {
        readonly name: string;
      } | null;
      readonly suite?: {
        readonly name: string;
      } | null;
      readonly team?: {
        readonly name: string;
      } | null;
      readonly user?: {
        readonly name: string;
      } | null;
      readonly uuid?: string;
    } | null;
    readonly type: AuditSubjectType | null;
  } | null;
  readonly type: AuditEventType;
  readonly uuid: string;
  readonly " $fragmentSpreads": FragmentRefs<"Drawer_auditEvent">;
  readonly " $fragmentType": "row_auditEvent";
};
export type row_auditEvent$key = {
  readonly " $data"?: row_auditEvent$data;
  readonly " $fragmentSpreads": FragmentRefs<"row_auditEvent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "row_auditEvent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Drawer_auditEvent"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "occurredAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditActor",
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Avatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "User",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v3/*: any*/),
              "type": "Agent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditSubject",
      "kind": "LinkedField",
      "name": "subject",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v3/*: any*/),
              "type": "Organization",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v3/*: any*/),
              "type": "Pipeline",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v3/*: any*/),
              "type": "Team",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "TeamMember",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Pipeline",
                  "kind": "LinkedField",
                  "name": "pipeline",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "TeamPipeline",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Registry",
                  "kind": "LinkedField",
                  "name": "registry",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "TeamRegistry",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Suite",
                  "kind": "LinkedField",
                  "name": "suite",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "TeamSuite",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Organization",
                  "kind": "LinkedField",
                  "name": "organization",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "Secret",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "context",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AuditEvent",
  "abstractKey": null
};
})();

(node as any).hash = "2b987bb7b87a844569113716036c0179";

export default node;
